module.exports = __webpack_public_path__ + "img/icon-quxaio.5e1232ff.svg";